import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { IBlockedDateChangeLogResponse } from "../../@types/blockedDates";

export interface IBlockedDatesChangeLogRequest {
  page: number;
  employee_id?: number;
}

export const GetBlockedDatesChangeLogApiService = async (
  request: IBlockedDatesChangeLogRequest
): Promise<IBlockedDateChangeLogResponse> => {
  const url = request.employee_id
    ? `/odp_limits/blocked_dates/employee_change_log/`
    : `/odp_limits/blocked_dates/employer_change_log/`;

  const { data } = await axios.get(url, {
    params: {
      page: request.page,
      ...(request.employee_id && { employee_id: request.employee_id }),
    },
  });

  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useGetBlockedDatesChangeLogApiService = (
  request: IBlockedDatesChangeLogRequest
) =>
  useQuery<
    IBlockedDateChangeLogResponse,
    AxiosError,
    IBlockedDateChangeLogResponse
  >(
    ["GetBlockedDatesChangeLogApiService", request.page, request.employee_id],
    () => GetBlockedDatesChangeLogApiService(request),
    { keepPreviousData: true }
  );

export default useGetBlockedDatesChangeLogApiService;
